module.exports = __webpack_public_path__ + "static/media/loneliness.d5de03bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/loneliness.jpg
// module id = 4380
// module chunks = 14